// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3g8LV","textarea":"styles_textarea__2SAqY"};